import React from "react";
import { Grid, GridSize } from "@mui/material";
import { Breakpoint } from "@mui/material/styles";

type Props = Omit<React.ComponentProps<typeof Grid>, "size"> & {
  size?: {
    [key in Breakpoint]?: GridSize | null;
  };
};

export default function TypographyItemContainer({
  size,
  ...props
}: Props): React.JSX.Element {
  return (
    <Grid className="scd-container-base" {...props} size={{ xs: 12, ...size }}>
      {props.children}
    </Grid>
  );
}
